import { Component, OnInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { DataFlightService, HttpService, HubSpokeService, HubSpokeAcknowledgeService, LoaderService, UtilityFlightService, UtilityService, XchangeratesService } from 'src/app/services';
import { CryptoService } from 'src/app/services/crypto.service';
import { AirlinelistComponent } from '../airlinelist/airlinelist.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Options } from '@angular-slider/ngx-slider';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { catchError, tap } from 'rxjs/operators';
import { ViewMultiFareComponent } from '../view-multi-fare/view-multi-fare.component';


@Component({
  selector: 'app-round-way-international',
  templateUrl: './round-way-international.component.html',
  styleUrls: ['./round-way-international.component.scss']
})
export class RoundWayInternationalComponent implements OnInit {
  isLoading: boolean = false;
  isBookingLoader: boolean = false;
  trip_type: any;
  filter = false;
  list;
  value: number = 0;
  flightList: any;
  flight_list: any = [];
  flight_Details: boolean[] = [];
  minValue: number;
  maxValue: number;
  stops = this.data.stopList;
  flightTime = this.data.flightTime;
  flightTimeArr = this.data.flightTime__;
  activeStates: { id: number, value: number, isSelected: boolean }[] = this.stops.map(stop => ({ id: stop.id, value: stop.value, isSelected: stop.isSelected }));
  activeDepart: { [key: string]: boolean } = {};
  activeArrival: { [key: string]: boolean } = {};
  flightcarrier_: any = [];
  newListCarrier: any = [];
  uniqueCarrierNames: any[] = [];
  flight_list_filter: any [] = [];
  currentOrder: string = 'asc';
  selectedFareIndex: number | null = null;

  flight_Details__: boolean[] = [false, false, false];
  list_error;
  currentIndex: number = 0; 
  itemsPerPage: number = 3;
  isMobile: boolean = false;
  // maxValue: any;
  options: Options = {
    floor: 0,
    ceil: 0,
  };

  displayedFlights: any[] = [];  // Flights to display (10 by default)
  showAllFlights: boolean = false;
  limit: number = 10; 
  flightBanner: any[]
  activeIndex__: number | null = 0; // Initially, the first index is active.
  
  constructor(public http: HttpService, public loaderService: LoaderService, private cryptoService: CryptoService, private dialog: MatDialog,
    public data: DataFlightService, public router: Router, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private util_flight: UtilityFlightService, public util: UtilityService,
    public Xchangerates: XchangeratesService, private breakpointObserver: BreakpointObserver, private hubSpokeService: HubSpokeService, private hubSpokeAcknowledgeService: HubSpokeAcknowledgeService) {
    this.trip_type = JSON.parse(localStorage.getItem('flight_search')!);
    this.fetchFlightList();
    this.loaderService.isLoading.next(true);
    localStorage.removeItem('PassangerRule');
  }

  ngOnInit(): void {
    this.initializeValues();
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
      this.itemsPerPage = this.isMobile ? 1 : 3;
    });
  }

  fetchFlightList(): void {
    this.isLoading = true;
    this.http.flightsave('apiV2/flight/search-multi-fare', this.trip_type).pipe(
      tap((res) => {
        if (res.statusCode !== 200) throw new Error('Invalid response code.');
        this.list = res.data;
        const flightlist = res.data.flightjourneys.map((j: any) => ({
          ...j,
          flightlegs: j.flightlegs.map((l: any, i: number) => {
            const layover = j.layovers?.[i] || {};
            (Array.isArray(l) ? l : [l]).forEach(n => n.stopover && (n.layover__ = layover));
            return l;
          }),
        }));
          this.router.url.includes('/cheap-flights') 
          ? this.fetchBannerList(flightlist.slice(0, 12)) 
          : this.processBannerList([], flightlist);
        this.lowhighList(flightlist);
        this.carrer_list(flightlist);
      }),
      catchError((err) => {
        this.util.errorMessage(err);
        this.list_error = 0;
        this.isLoading = false;
        return [];
      })
    ).subscribe({ complete: () => this.isLoading = false });
  }

  toggleFlights(): void {
    if (this.router.url.includes('/cheap-flights')) {
      this.showAllFlights = !this.showAllFlights;
      if (this.showAllFlights) {
        this.flight_list = [...this.list.flightjourneys];  // Show all flights
        this.processBannerList(this.flightBanner, this.flight_list);
        
      } else {
        this.flight_list = this.list.flightjourneys.slice(0, 12);  // Limit to 10
        this.processBannerList(this.flightBanner, this.flight_list);

        this.cdr.detectChanges();
      }
    }
  }

  fetchBannerList(flightlist: any[]): void {
    this.http.flightget('apiV2/bookingClass/search-page-banner-list').subscribe({
      next: (res) => {
        const bannerPromo = this.util_flight.getFlightsByType(); 
        const filteredData = res.data.filter((item: any) => item.way_type === 'BOTH' || (item.way_type === 'DOMESTIC' && (bannerPromo.type === 'domestic' || bannerPromo.type === 'both')) || (item.way_type === 'INTERNATIONAL' && (bannerPromo.type === 'international' || bannerPromo.type === 'both')) || item.way_type === null).sort((a: any, b: any) => a.banner_priority === null ? 1 : b.banner_priority === null ? -1 : a.banner_priority - b.banner_priority);
        this.flightBanner = filteredData
        this.processBannerList(filteredData, flightlist);
      },
      error: () => this.processBannerList([], flightlist)
    });
  }
  
  private processBannerList(bannerlist: any[], flightlist: any[]): void {
    this.flight_list = [];
    let bannerIndex = 0;
    flightlist.forEach((flight, i) => {
      this.flight_list.push({ ...flight, name: 'flight' });
      if ((i + 1) % 3 === 0 && i !== flightlist.length - 1 && bannerlist.length) {
        this.flight_list.push({ ...bannerlist[bannerIndex], name: 'banner' });
        bannerIndex = (bannerIndex + 1) % bannerlist.length;
      }
    });
    this.flight_list_filter = [...this.flight_list];
    this.isLoading = false;
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  
  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }
  
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  lowhighList(flightlist: any[]) {
    // Check if the mergedList is not empty
    if (flightlist.length === 0) {
      // console.log('The mergedList is empty.');
      return;
    }

    // Initialize variables to store the minimum and maximum values
    let lowestValue = Number.MAX_VALUE;
    let highestValue = Number.MIN_VALUE;

    for (const item of flightlist) {
      // Assuming each item in mergedList has a numeric value
      const value = parseFloat(item.multifares[0].flightfare.totalnet); // Convert the value to a number (assuming it's a string)
      // Check for the lowest value
      if (!isNaN(value) && value < lowestValue) {
        lowestValue = value;
      }
      // Check for the highest value
      if (!isNaN(value) && value > highestValue) {
        highestValue = value;
      }
    }
    // Log the lowest and highest values
    this.minValue = lowestValue;
    this.maxValue = highestValue;
    this.options.floor = lowestValue;
    this.options.ceil = highestValue;
  }

  carrer_list(flightlist: any[]) {
    const newList: any[] = flightlist.map((flight_List_) => flight_List_);
    const filteredList: any[] = newList.filter((item) => item.name !== 'banner');
    const carrierList_: string[] = filteredList.flatMap((flight) => flight.flightlegs);
    const carrierNames: string[] = carrierList_.map((carrier) => carrier);
    const allCarrierNames: any[] = [];
    for (const carrierName of carrierNames) {
      for (const listcarrier of carrierName) {
        this.flightcarrier_ = listcarrier;
        this.newListCarrier = { carriername: this.flightcarrier_.carriername, carrier: this.flightcarrier_.carrier };
        allCarrierNames.push(this.newListCarrier);
      }
    }
    const uniqueCarrierNames = Array.from(new Set(allCarrierNames.map(carrier => `${carrier.carriername} (${carrier.carrier})`)));
    const uniqueCarrierNames_ = uniqueCarrierNames.map(carrier => {
      const code = carrier.match(/\((.*?)\)/)?.[1] || ''; // Extract code between parentheses
      return { name: carrier, code: code, isSelected: false };
    });
    this.uniqueCarrierNames = uniqueCarrierNames_;
  }

  flightInfo(i: number): void {
    this.flight_Details[i] = !this.flight_Details[i];
    this.flight_Details__[i] && (this.flight_Details__[i] = false);
  }

  submit(item, item_fare){
    this.proceedSubmit(item, item_fare);
  }

  proceedSubmit(item, item_fare){
    this.isBookingLoader = true;
    // const urlObject = new URL(item_fare.flightdeeplinkurl);
    // console.log(urlObject);
    const url = item_fare.flightdeeplinkurl.startsWith('/') ? item_fare.flightdeeplinkurl.slice(1) : item_fare.flightdeeplinkurl;
    const urlObject = new URL(url);
    // console.log(urlObject.pathname);

    const searchParams = urlObject.searchParams;
    const queryString = new URLSearchParams(searchParams).toString();

    this.http.flightgetall(`${urlObject.pathname}?${queryString}`).subscribe((res) => {
      if(res) {
        localStorage.setItem('flightSelect_0', JSON.stringify({infoFlight: item, infoFare: item_fare}));  // JSON.stringify(item)
        const bookingId = this.cryptoService.encrypt(res.booking_id);
        localStorage.setItem('bookingId', bookingId);
        localStorage.setItem('trip_type__', 'round_international');
        const id = res.booking_id;
        localStorage.setItem('PassangerRule', JSON.stringify(res));
        // this.util_flight.pushPassangerRule(res);
        this.router.navigate([`../bookings/${id}`], { relativeTo: this.route }); // This will be used in future after getting payment result
        // const url = this.router.createUrlTree([`../bookings/${id}`], { relativeTo: this.route }).toString();
        // window.open(url, '_blank');
        this.isBookingLoader = false;
      }
    }, err => {
      this.util.errorMessage(err);
      this.isBookingLoader = false;
    });
  }

  selectStop(stop: any) {
    stop.isSelected = !stop.isSelected;
    this.activeStates = this.stops.map(stop => ({ id: stop.id, value: stop.value, isSelected: stop.isSelected }));
    const selectedStops = this.activeStates.filter(state => state.isSelected);
    const selectedAirlines = this.uniqueCarrierNames.filter(item => item.isSelected);
    this.filterFlightList(selectedStops, selectedAirlines);
  }

  // This Filter is used for Airlines
  filter_airline(item: any) {
    item.isSelected = !item.isSelected;
    const selectedItems = this.uniqueCarrierNames.filter(i => i.isSelected);
    this.flight_list = selectedItems.length > 0 ?
      this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
          selectedItems.some(selectedItem => flightleg.carrier === selectedItem.code)
        )
      ) : this.flight_list_filter;
  }


  private filterFlightList(selectedStops: any[], selectedAirlines: any[]) {
    const filterCondition = (flight: any, length: number) => flight.layovers && flight.layovers[0] && Object.keys(flight.layovers[0]).length === length;

    if (!selectedStops.length && !selectedAirlines.length) {
      this.flight_list = this.flight_list_filter;
      // console.log(this.flight_list);
      return;
    }

    this.flight_list = this.flight_list_filter.filter(flight =>
      (!selectedStops.length || selectedStops.some(selectedStop => selectedStop.value >= 0 && selectedStop.value <= 3 && selectedStop.isSelected && filterCondition(flight, selectedStop.value))) &&
      (!selectedAirlines.length || flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
        selectedAirlines.some(selectedItem => flightleg.carrier === selectedItem.code)
      ))
    );
  }

  onValueChange(event: any) {
    this.cdr.detectChanges();
    this.flight_list = this.filterFlights(this.minValue, this.maxValue);
  }
  
  filterFlights(minValue: number, maxValue: number): any[] {
    const filteredFlights = this.flight_list_filter.filter(flight =>
      flight.flightfare && flight.flightfare.totalnet != null &&
      flight.flightfare.totalnet >= minValue && flight.flightfare.totalnet <= maxValue
    );
    if (filteredFlights.length === 0) this.flight_list = this.flight_list_filter;
    return filteredFlights;
  }

  selectedDepartureTimeRanges: { startTime: string, endTime: string }[] = [];
  selectedArrivalTimeRanges: { startTime: string, endTime: string }[] = [];

  selectDepart(item) {
    item.isSelected = !item.isSelected;
    if (item.isSelected) {
      const timeRanges = ['00:00-12:00', '12:01-18:00', '18:01-23:59'];
      this.selectedDepartureTimeRanges.push({ startTime: timeRanges[item.id].split('-')[0], endTime: timeRanges[item.id].split('-')[1] });
    } else {
      this.selectedDepartureTimeRanges = this.selectedDepartureTimeRanges.filter(range =>
        !(range.startTime === '00:00' && range.endTime === '12:00' && item.id === 0) &&
        !(range.startTime === '12:01' && range.endTime === '18:00' && item.id === 1) &&
        !(range.startTime === '18:01' && range.endTime === '23:59' && item.id === 2)
      );
    }
    this.filterByDepartureTime();
  }

  private filterByDepartureTime() {
    if (this.selectedDepartureTimeRanges.length > 0) {
      const filteredFlights = this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs[0][0] &&
        this.selectedDepartureTimeRanges.some(range =>
          flight.flightlegs[0][0].deptime >= range.startTime && flight.flightlegs[0][0].deptime <= range.endTime
        )
      );
      this.flight_list = filteredFlights;
    } else {
      // If no time ranges are selected, show all flights
      this.flight_list = this.flight_list_filter;
    }
  }
  selectArrival(item) {
    item.isSelected_ = !item.isSelected_;
    if (item.isSelected_) {
      const timeRanges = ['00:00-12:00', '12:01-18:00', '18:01-23:59'];
      this.selectedArrivalTimeRanges.push({ startTime: timeRanges[item.id].split('-')[0], endTime: timeRanges[item.id].split('-')[1] });
    } else {
      this.selectedArrivalTimeRanges = this.selectedArrivalTimeRanges.filter(range =>
        !(range.startTime === '00:00' && range.endTime === '12:00' && item.id === 0) &&
        !(range.startTime === '12:01' && range.endTime === '18:00' && item.id === 1) &&
        !(range.startTime === '18:01' && range.endTime === '23:59' && item.id === 2)
      );
    }
    this.filterByArrivalTime();
  }

  private filterByArrivalTime() {
    if (this.selectedArrivalTimeRanges.length > 0) {
      const filteredFlights = this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs[0][flight.flightlegs[0].length - 1] &&
        this.selectedArrivalTimeRanges.some(range =>
          flight.flightlegs[0][flight.flightlegs[0].length - 1].arrtime >= range.startTime && flight.flightlegs[0][flight.flightlegs[0].length - 1].arrtime <= range.endTime
        )
      );
      this.flight_list = filteredFlights;
    } else {
      // If no time ranges are selected, show all flights
      this.flight_list = this.flight_list_filter;
    }
  }

  airlinelist(item) {
    const selectedItems = item.filter(i => i.isSelected);
    const dialogRef = this.dialog.open(AirlinelistComponent, {
      data: { allItems: item, selectedItems },
      width: '520px',
      panelClass: 'flight_airlinelist-dialog-container',
      disableClose: false
    });
    // dialogRef.componentInstance.airlinesSelected.subscribe((selectedAirlines: any[]) => {
    // });
    dialogRef.afterClosed().subscribe(result => {
      this.updateFlightList(result ?? []);
      this.uniqueCarrierNames = this.uniqueCarrierNames.map(i => ({
        ...i,
        isSelected: (result ?? []).some(selected => selected.name === i.name) || false
      }));
    });
  }

  private updateFlightList(selectedAirlines: any[]) {
    if (selectedAirlines?.length === 0) {
      this.flight_list = this.flight_list_filter;
    } else {
      this.flight_list = this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
          selectedAirlines.some(selectedItem => flightleg.carrier === selectedItem.code)
        )
      );
    }
  }

  sortBy(criteria: string) {
    if (this.currentOrder === 'asc') {
      switch (criteria) {
        case 'departure':
        case 'arrive':
          this.sortFlightList('asc');
          break;
        case 'price':
          this.sortFlightPrice('asc');
          break;
          case 'duration':
          this.sortFlightDuration('asc');
          break;
        // Add cases for other criteria if needed
      }
      this.currentOrder = 'desc';
    } else {
      switch (criteria) {
        case 'departure':
        case 'arrive':
          this.sortFlightList('desc');
          break;
        case 'price':
          this.sortFlightPrice('desc');
          break;
          case 'duration':
          this.sortFlightDuration('desc');
          break;
        // Add cases for other criteria if needed
      }
      this.currentOrder = 'asc';
    }
  }

 
  sortFlightDuration(order: string) {
    const sortOrder = order === 'asc' ? 1 : -1;
    const durations = this.flight_list_filter
      .map(flight => {
        const totalDuration = flight.totaljourneyduration || 0;
        return { flight, totalDuration };
      })
      .sort((a, b) => (a.totalDuration - b.totalDuration) * sortOrder);
    this.flight_list = durations.map(item => item.flight);
  }

  sortFlightList(order: string) {
    const departureTimes = this.flight_list_filter
      .map(flight => flight.flightlegs?.[0]?.[0]?.deptime)
      .filter(departureTime => departureTime);
    const sortOrder = order === 'asc' ? 1 : -1;
    departureTimes.sort((a, b) => (this.util_flight.convertTimeStringToMinutes(a) - this.util_flight.convertTimeStringToMinutes(b)) * sortOrder);
    this.flight_list = departureTimes.map(departureTime => this.flight_list_filter.find(flight => flight.flightlegs?.[0]?.[0]?.deptime === departureTime));
  }

  sortFlightPrice(order: string) {
    const priceFlight = this.flight_list_filter
      .map(flight => flight.flightfare)
      .filter(totalnet => totalnet);
    const priceOrder = order === 'asc' ? 1 : -1;
    priceFlight.sort((a, b) => (a - b) * priceOrder);
    if (order === 'desc') priceFlight.reverse();
    this.flight_list = priceFlight.map(price => this.flight_list_filter.find(flight => flight.flightfare === price));
  }


  flightInfo__(index: number): void {
    const dialogRefMULTIFARE = this.dialog.open(ViewMultiFareComponent, {
          data: index, 
          panelClass: 'flight_multiFare-dialog-container',
          width: '920px',
        });
    
        dialogRefMULTIFARE.afterClosed().subscribe((result) => {
          if(result) {
            this.submit(result.item, result.item_fare)
          }
        })
  }

  step = 0;  // Variable to keep track of the currently open panel

  selected_fare(index: number) {
    this.selectedFareIndex = index; // Update the selected fare index
  }
  
  setStep(index: number) {
    this.step = index;
  }

  adultNum: number = 0;
  childNum: number = 0;
  infantNum: number = 0;

  initializeValues() {
    // Retrieve numbers of adults, children, infants, etc.
    this.adultNum = JSON.parse(localStorage.getItem('adultValue') || '0');
    this.childNum = JSON.parse(localStorage.getItem('childValue') || '0');
    this.infantNum = JSON.parse(localStorage.getItem('infantsValue') || '0');
    // console.log(this.adultNum, this.childNum, this.infantNum);
  }

  hasFeatureArray(multifares: any[]): boolean {
    if (!multifares) return false;
    return multifares.some(mf => 
      mf.faretype?.some(ft => Array.isArray(ft.features) && ft.features.length > 0)
    );
  }
}
